var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading"
        }
      ],
      staticClass: "main-content",
      attrs: {
        "element-loading-text": "Loading...",
        "element-loading-spinner": "el-icon-loading",
        "element-loading-background": "rgba(170,170,170,0.5)"
      }
    },
    [
      _c("div", { staticClass: "section operations" }, [
        _c("div", { staticClass: "triggers" }, [
          _c(
            "div",
            [
              _c("div", { staticClass: "input-label" }, [
                _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Filter")))
              ]),
              _c("el-input", {
                staticStyle: { width: "180px" },
                model: {
                  value: _vm.keyword,
                  callback: function($$v) {
                    _vm.keyword = $$v
                  },
                  expression: "keyword"
                }
              }),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "permission",
                      rawName: "v-permission",
                      value: ["button_AirRegion_add"],
                      expression: "['button_AirRegion_add']"
                    }
                  ],
                  attrs: { type: "primary" },
                  on: { click: _vm.newHandler }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Add")))]
              ),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "permission",
                      rawName: "v-permission",
                      value: ["button_AirRegion_edit"],
                      expression: "['button_AirRegion_edit']"
                    }
                  ],
                  attrs: { type: "primary" },
                  on: { click: _vm.editHandler }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Edit")))]
              ),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "permission",
                      rawName: "v-permission",
                      value: ["button_AirRegion_delete"],
                      expression: "['button_AirRegion_delete']"
                    }
                  ],
                  attrs: { type: "primary" },
                  on: { click: _vm.delHandler }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Delete")))]
              )
            ],
            1
          )
        ])
      ]),
      _c(
        "div",
        { staticStyle: { "flex-grow": "1", "min-height": "350px" } },
        [
          _c("cargo-ag-grid", {
            staticStyle: { height: "100%" },
            attrs: {
              "grid-options": _vm.gridOptions,
              "column-defs": _vm.columnDefs,
              "row-data": _vm.filteredRowData
            },
            on: {
              gridReady: function(params) {
                _vm.gridApi = params.api
              }
            }
          })
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          staticClass: "region-form",
          attrs: {
            visible: _vm.regionDialog.visible,
            title: _vm.regionDialog.title,
            width: "500px",
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.regionDialog, "visible", $event)
            }
          }
        },
        [
          _c(
            "el-form",
            {
              attrs: {
                "label-width": _vm.$selectByLang("70px", "120px"),
                "label-position": "left"
              }
            },
            [
              _c(
                "el-form-item",
                {
                  staticClass: "lable-blue",
                  attrs: { label: _vm.$t("CargoMsg.Cargo_Code") }
                },
                [
                  _c("el-input", {
                    staticStyle: { width: "150px" },
                    attrs: {
                      placeholder: _vm.$t("CargoMsg.Cargo_MustBEntered")
                    },
                    model: {
                      value: _vm.regionDialog.form.code,
                      callback: function($$v) {
                        _vm.$set(_vm.regionDialog.form, "code", $$v)
                      },
                      expression: "regionDialog.form.code"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "lable-blue",
                  attrs: { label: _vm.$t("CargoMsg.Cargo_Name") }
                },
                [
                  _c("el-input", {
                    staticStyle: { width: "150px" },
                    attrs: {
                      placeholder: _vm.$t("CargoMsg.Cargo_MustBEntered")
                    },
                    model: {
                      value: _vm.regionDialog.form.name,
                      callback: function($$v) {
                        _vm.$set(_vm.regionDialog.form, "name", $$v)
                      },
                      expression: "regionDialog.form.name"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("CargoMsg.Cargo_EnglishNamed") } },
                [
                  _c("el-input", {
                    staticStyle: { width: "230px" },
                    attrs: { placeholder: " " },
                    model: {
                      value: _vm.regionDialog.form.englishName,
                      callback: function($$v) {
                        _vm.$set(_vm.regionDialog.form, "englishName", $$v)
                      },
                      expression: "regionDialog.form.englishName"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "section", staticStyle: { height: "290px" } },
            [
              _c("span", { staticClass: "title" }, [
                _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_RegionalPorts")))
              ]),
              _c("cargo-ag-grid", {
                attrs: {
                  "grid-options": _vm.regionDialog.gridOptions,
                  "column-defs": _vm.regionDialog.columnDefs,
                  "row-data": _vm.regionDialog.form.airPortRegion || []
                },
                on: {
                  gridReady: function(params) {
                    _vm.regionDialog.gridApi = params.api
                  }
                }
              })
            ],
            1
          ),
          _c(
            "span",
            {
              staticStyle: { display: "flex" },
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.addAirPortRegion }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_add")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.delAirPortRegion }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Delete")))]
              ),
              _c("div", { staticStyle: { "flex-grow": "1" } }),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.commitHandler }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Confirm")))]
              ),
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.regionDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("Message.Cancel")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _c("air-port-select-dialog", {
        attrs: {
          visible: _vm.airPortSelectDialog.visible,
          codes: _vm.airPortSelectDialog.codes
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.airPortSelectDialog, "visible", $event)
          },
          callback: _vm.selectAirPorts
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }